<template>
    <div class="container px-8 mx-auto md:w-96 sm:w-96">
      <Card class="mt-6">
        <form action="" class="w-full bg-gray-600 px-4 py-4" @submit.prevent="updateMode ? UpdateCategory() : AddCategory()" >
          <label class="block text-sm mb-1  mt-1">عنوان</label>
          <Input class="" placeholder="عنوان " v-model="category.Name"
                 :error="error.Name" @keydown="error.Name = ''"/>
          <label class="block text-sm mb-1 mr-1 mt-1">ترتیب</label>
          <Input class="" placeholder="ترتیب " v-model="category.SortOrder"
                 :error="error.SortOrder" @keydown="error.SortOrder = ''"/>
          <div class="flex mt-4 mb-1 mr-1 ">
            <label for="default" class="block text-sm">فعال </label>
            <input id="default" type="checkbox" v-model="category.isActive">
          </div>
          <!--<div class="rounded-xl overflow-hidden mt-4">
            <div id="map" class="h-64 z-0"></div> change rahim
          </div>-->
  
          <Button class="w-32 mt-2 mr-16 bg-blue-400">ثبت</Button>
        </form>
      </Card>
    </div>
  </template>
  
  <script>
  import Card from "@/components/General/VCard";
  import Input from "@/components/General/VInput";
  import Button from "@/components/General/VButton";
  import {CreateCategory, getCategory, UpdateCategory} from "@/API/API.js";
  
  export default {
    name: "AddCategory",
    components: {Card, Input, Button,},
    data() {
      return {
        catid:0,
        menuid:0,
        updateMode: false,
        category: {
          Id:0,
          Name: '',
          ScreenMenuId:0,
          isActive: false,
          SortOrder:0
        },
        error: {
          Name: '',
        }
      }
    },
    async mounted() {
      //console.log(123456)
      this.menuid = this.$route.params.id
      this.category.ScreenMenuId=this.menuid ;
      this.catid = this.$route.params.catid
      //console.log(this.menuid )
      if (this.catid) {
        this.updateMode = true;
        this.$Progress.start()
        //let tmpmenu = (await getCategory(this.catid)).data.result
        let tmpmenu = (await getCategory(this.catid)).data
        this.$Progress.finish()
        //console.log(tmpmenu)
        //console.log(tmpmenu.SortOrder)
        //console.log(tmpmenu.isActive)
        this.category.Name=tmpmenu.name;
        this.category.SortOrder=tmpmenu.sortOrder;
        this.category.isActive=tmpmenu.isActive;
        this.category.Id=tmpmenu.id;
      }      
    },
    methods: {
      AddCategory() {
        if (this.validatecategory()) {
          this.$Progress.start()
          //console.log(this.category)
          CreateCategory(this.$store.getters.slug,this.category)
              .then(() => {
                this.$Progress.finish()
                //console.log(this.id)
                this.$router.push('/menu/'+this.menuid )
                //if (this.$route.query.redirect) {
                // this.$router.push(this.$route.query.redirect)
                //} else {
                 // this.$router.push('/menu/${id}')
                //}
              })
        }
      },
      UpdateCategory() {
        if (this.validatecategory()) {
          this.$Progress.start()
          //console.log(this.category)
          UpdateCategory(this.$store.getters.slug, this.category)
              .then(() => {
                this.$Progress.finish()
                this.$router.push('/menu/'+this.menuid )
              })
        }
      },
      validatecategory() {
        let result = true
        if (!this.category.Name) {
          this.error.storeName = 'لطفا عنوان را وارد نمایید.'
          result = false
        }
        return result
      }
    }
  }
  </script>
  
